//http://localhost:8080/#/?leftEar=24,23,24,18,25,27,18&rightEar=25,35,38,38,36,39,30
//（500Hz + 1000 + 2000+ 4000）/ 4
<script>
import HelloWorld from './components/HelloWorld.vue'
import frequecyDsc from './components/frequecyDsc.vue'
import hearingNum from './components/HearingNum.vue'

export default {
  name: 'App',
  computed: {
    HelloWorld () {
      return HelloWorld
    },
    frequecyDscPage () {
      return frequecyDsc
    },
    hearingNumPage () {
      return hearingNum
    }
  },
  data () {
    return {
      dataHearing: this.getUrlKey(),
      imgLogo: require('./assets/logo.svg'),
      imgProgress: require('./assets/progress.svg'),
      imgProgress_small: require('./assets/progress_small.svg'),
      imgAid: require('./assets/aid.svg'),
      imgBack: require('./assets/back.svg'),
      imgBack_samll: require('./assets/back_small.svg')
    }
  },
  methods: {
    getUrlKey () {
      let url = window.location.href
      let dzUrl = url.split('#')[1]
      let cs = dzUrl.split('?')[1]
      let csArr = cs.split('&')
      let csResult = {}

      for (let i = 0; i < csArr.length; i++) {
        csResult[csArr[i].split('=')[0]] = csArr[i].split('=')[1]
      }
      let leftEarArr = csResult.leftEar
      const leftShowArray = leftEarArr.split(',')
      let leftThresholdNum = []
      let dataIntArrLeft = []
      if (leftShowArray.length > 1) {
        dataIntArrLeft = leftShowArray.map(function (data) {
          return +data
        })
        leftThresholdNum = ((dataIntArrLeft[2] + dataIntArrLeft[3] + dataIntArrLeft[4] + dataIntArrLeft[5]) / 4).toFixed(0)
        console.log(dataIntArrLeft[1])
        dataIntArrLeft.unshift(null)
      }
      let rightEarArr = csResult.rightEar
      const rightShowArray = rightEarArr.split(',')
      let rightThresholdNum = []
      let dataIntArrRight = []
      if (rightEarArr.length > 1) {
        dataIntArrRight = rightShowArray.map(function (data) {
          return +data
        })
        rightThresholdNum = ((dataIntArrRight[2] + dataIntArrRight[3] + dataIntArrRight[4] + dataIntArrRight[5]) / 4).toFixed(0)
        dataIntArrRight.unshift(null)
        console.log(dataIntArrRight)
      }

      let lossMax = Math.max(leftThresholdNum, rightThresholdNum)
      if (dataIntArrRight.length !== 8) {
        rightThresholdNum = 'unknown'
        lossMax = leftThresholdNum
      }
      if (dataIntArrLeft.length !== 8) {
        leftThresholdNum = 'unknown'
        lossMax = rightThresholdNum
      }

      let lossMaxLevel = 1
      switch (true) {
        case (lossMax > 0 && lossMax < 20):
          lossMaxLevel = 0
          break
        case (lossMax > 20 && lossMax < 35):
          lossMaxLevel = 1
          break
        case (lossMax >= 35 && lossMax < 50):
          lossMaxLevel = 2
          break
        case (lossMax >= 50 && lossMax < 65):
          lossMaxLevel = 3
          break
        case (lossMax >= 65 && lossMax < 80):
          lossMaxLevel = 4
          break
        case (lossMax >= 80):
          lossMaxLevel = 5
          break
        default:
          lossMaxLevel = 2
          break
      }

      return {
        leftEar: dataIntArrLeft,
        rightEar: dataIntArrRight,
        leftThreshold: leftThresholdNum,
        rightThreshold: rightThresholdNum,
        lossLevel: lossMaxLevel
      }
    },
    btnclicked: function () {
      window.open('https://elehear.com/products/elehear-alpha-50')
    }
  }
}

</script>

<template>
  <div class="app">
    <div style="margin-top: 30px;">
      <img :src="imgLogo" alt style="width: 292px; height: 80px; display:flex; margin: auto;"/>
    </div>
    <div style="margin-top: 20px;">
      <img :src="imgProgress" alt class="default-image"/>
      <img :src="imgProgress_small" alt class="small-image"/>
    </div>
    <div class="center-columnMain">
      <p class="titleTextBox">Interpreting your audiogram</p>
      <div class="box_settings_audioGram">
        <div id="center-column">
          <div class="chartStylePos">
            <p class="verticalTextBox">Hearing Level (dB)</p>
            <component :is="HelloWorld" :leftNum=this.dataHearing.leftEar :rightNum=this.dataHearing.rightEar
                       :chartWidth=484 :chartHeight="613"></component>
          </div>
        </div>
        <div class="center-column2">
          <component :is="hearingNumPage" :leftNum=this.dataHearing.leftThreshold
                     :rightNum=this.dataHearing.rightThreshold></component>
          <component :is="frequecyDscPage" :dataLevel=this.dataHearing.lossLevel></component>
        </div>
      </div>
    </div>
    <div class="floatPos">
      <img :src="imgBack" alt class="default-image-back"/>
      <img :src="imgBack_samll" alt class="small-image-back"/>
      <button class="floatButton" @click='btnclicked'>
        BUY NOW
      </button>

      <button class="floatButton_small" @click='btnclicked'>
        BUY NOW
      </button>
    </div>
  </div>
</template>

<style>
body {
  margin: 0;
}
.app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f3f3f3;
  align-items: center;
  padding-bottom: 60px;
}

#center-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.floatPos {
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  position: relative; /* 或者 fixed 或者 absolute */
  justify-content: center;
  margin-top: 30px;
}

.verticalTextBox {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  font-size: 15px;
  font-weight: bold;
  transform: rotate(180deg);
  margin-top: 200px;
  width: 10px;
  height: 200px;
  line-height: 70px;
  text-align: center;
  writing-mode: vertical-rl;
}

.titleTextBox {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  font-size: 30px;
  font-weight: bold;
  line-height: 70px;
  text-align: center;
}

.center-columnMain {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f2f2f2;
  margin-top: 20px;
  border-radius: 10px;
  width: 1030px;
}

.box_settings_audioGram {
  display: grid;
  grid-template-columns: 50% 50%; /* 横向排列，自适应宽度 */
  gap: 10px; /* 间隙，可选 */
  border-radius: 22px;
  background: #FFFFFF;
}

.center-column2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 30px;
}

@media (max-width: 768px) {
  .app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #f3f3f3;
    align-items: center;
    padding-bottom: 60px;
    width: 100%;
    height: 100%;
    border: 0;
  }

  .floatPos {
    display: flex;
    position: relative; /* 或者 fixed 或者 absolute */
    justify-content: center;
    margin-top: 30px;
  }

  .box_settings_audioGram {
    display: grid;
    grid-template-columns: 100%; /* 设置列宽占父容器宽度的50% */
    gap: 5px; /* 间隙，可选 */
    margin-left: 1px;
    margin-right: 1px;
    background: #f2f2f2;
  }

  .center-columnMain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    width: 98%;
  }

  .center-column2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 30px;
  }

  .titleTextBox {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    font-size: 30px;
    font-weight: bold;
    line-height: 40px;
    text-align: center;
  }

  .verticalTextBox {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    font-size: 15px;
    font-weight: bold;
    transform: rotate(180deg);
    margin-top: 200px;
    margin-left: 10px;
    margin-right: 20px;
    width: 10px;
    height: 200px;
    line-height: 70px;
    text-align: center;
    writing-mode: vertical-rl;
  }

}

.small-image, .default-image, .small-image-back, .default-image-back, .floatButton, .floatButton_small, .chartStylePos {
  display: none;
}

/* 在小屏幕下显示小图片 */
@media (max-width: 768px) {
  .small-image {
    display: flex;
    margin: auto;
    width: 100%;
  }

  .small-image-back {
    display: flex !important;
    margin: auto;
    width: 320px;
    height: 150px !important;
    border-radius: 10px;
  }

  .floatButton_small {
    display: flex;
    display: -webkit-box;
    position: absolute !important;
    z-index: 2;
    bottom: 5% !important;
    left: 12% !important;
    width: 80px;
    height: 24px;
    border: 1px solid rgba(86, 86, 86, 1);
    border-radius: 32px;
    background: #FF6D00;
    color: rgb(255, 255, 255);
    font-size: 8px !important;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
  }

  .chartStylePos {
    display: flex;
    flex-direction: row;
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    margin-left: -30px;
  }

  .showChartClass_small {
    display: flex;
    text-align: center;
  }
}

/* 在大屏幕下显示大图片 */
@media (min-width: 901px) {
  .default-image {
    display: flex;
    width: 100%;
    height: 50px;
    margin: auto;
  }

  .default-image-back {
    display: flex;
    display: -webkit-box;
    display: -ms-flexbox;
    width: 1030px;
    height: 486px;
    border-radius: 32px;
  }

  .floatButton {
    display: flex;
    position: absolute !important;
    z-index: 2;
    bottom: 8% !important;
    left: 10% !important;
    width: 170px;
    height: 56px;
    flex-shrink: 0;
    border: 1px solid rgba(86, 86, 86, 1);
    border-radius: 32px;
    background: #FF6D00;
    color: rgb(255, 255, 255);
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.025em;
    text-align: center;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
  }

  .chartStylePos {
    display: flex;
    flex-direction: row;
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
  }

  .showChartClass {
    display: flex;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue